/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import Checkbox from '../Checkbox';
import { ErrorIcon, ErrorValidation } from '../ErrorValidation';
import RequireIndicator from '../RequireIndicator';

/* ----------------------------------
   Styled components
---------------------------------- */

interface LabelProps {
  fontSize?: string;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const CheckboxWrapper = styled.div`
  width: 33%;
`;

const Label = styled.label<LabelProps>`
  font-size: ${({ fontSize }) =>
    fontSize ? fontSize : '12px'};
  font-weight: bold;
  color: #666;
  display: flex;
  width: 100%;
  margin-bottom: 5px;
`;

/* ----------------------------------
   Types
---------------------------------- */

interface TransactionType {
  type: string;
  value: boolean;
}

interface TransactionTypesProps {
  id: string;
  types?: TransactionType[];
  category: string;
  dispatch: (action: any) => any;
  apiService: any;
  store: any;
  handleOnChange?: (
    type: string,
    payload: any
  ) => void;
  required?: boolean;
  isError?: boolean;
  isTouched?: boolean;
  errorMessage?: string;
}

/* ----------------------------------
   Component
---------------------------------- */

function TransactionTypes({
  id,
  types,
  category,
  dispatch,
  apiService,
  store,
  handleOnChange,
  required,
  isError,
  isTouched,
  errorMessage
}: TransactionTypesProps): JSX.Element {
  const { t } = useTranslation();

  const transactionTypes =
    types &&
    types.length &&
    types.map(type => (
      <CheckboxWrapper key={`${id}.${type.type}`}>
        <Checkbox
          name={type.type}
          label={t(
            `${category}.cards.${type.type}.label`
          )}
          checked={type.value}
          dispatch={dispatch}
          cardId={id}
          apiService={apiService}
          store={store}
          /* ✅ FIX: ensure correct function signature */
          handleOnChange={
            handleOnChange ?? (() => {})
          }
        />
      </CheckboxWrapper>
    ));

  return (
    <Wrapper>
      <Label>
        {required && <RequireIndicator />}
        {t('messages.transactionTypes')}
      </Label>

      {isError && isTouched && (
        <ErrorValidation>
          <ErrorIcon />
          <p>{errorMessage}</p>
        </ErrorValidation>
      )}

      {transactionTypes && transactionTypes.length > 0
        ? transactionTypes
        : ''}
    </Wrapper>
  );
}

export default TransactionTypes;